class DataStatistic extends HTMLElement {
  connectedCallback() {
    this.numberContent = this.querySelector("span");
    //console.log('Initial number content:', this.numberContent);
    this._hasAnimated = false;
    this.min = parseInt(this.getAttribute("data-min") || "0", 10);
    this.max = parseInt(this.getAttribute("data-max") || "0", 10);
    this.duration = parseInt(this.getAttribute("data-duration") || "1500", 10);

    // Respect prefers-reduced-motion for accessibility and sets the final number directly
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) {
      this.numberContent = this.formatNumber(this.max);
      return;
    }

    // Find the closest parent section
    const parentSection = this.closest("div.data-statistics");
    if (parentSection) {
      this._observer = new window.IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this._hasAnimated) {
              this._hasAnimated = true;
              this.animateNumberCounter(this.min, this.max, this.duration);
              observer.disconnect();
            }
          });
        },
        { threshold: 0.2 },
      );
      this._observer.observe(parentSection);
    } else {
      // Animate immediately if no parent section found
      this.animateNumberCounter(this.min, this.max, this.duration);
    }
  }

  formatNumber(num) {
    return num.toLocaleString();
  }

  animateNumberCounter(min, max, duration) {
    const start = +min;
    const end = +max;
    const range = end - start;
    const startTime = performance.now();
    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const value = Math.floor(progress * range + start);
      this.numberContent.textContent = this.formatNumber(value);
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        this.numberContent.textContent = this.formatNumber(end);
      }
    };
    requestAnimationFrame(step);
  }
}

if (!window.customElements.get("data-statistic")) {
  window.customElements.define("data-statistic", DataStatistic);
}
